import { render, staticRenderFns } from "./BusinessInformations.vue?vue&type=template&id=3dcde98f&"
import script from "./BusinessInformations.vue?vue&type=script&lang=js&"
export * from "./BusinessInformations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports